import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiClock } = FiIcons;

const InsightCard = ({ 
  title, 
  description, 
  priority = 'medium',
  category,
  actions = [],
  timestamp,
  icon
}) => {
  const priorityClasses = {
    high: 'border-l-danger-500 bg-danger-50',
    medium: 'border-l-warning-500 bg-warning-50',
    low: 'border-l-success-500 bg-success-50',
  };

  const priorityTextClasses = {
    high: 'text-danger-700',
    medium: 'text-warning-700',
    low: 'text-success-700',
  };

  return (
    <motion.div 
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
      className={`bg-white rounded-xl shadow-sm border-l-4 ${priorityClasses[priority]} p-6 hover:shadow-md transition-shadow`}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          {icon && (
            <div className="w-10 h-10 bg-secondary-100 rounded-lg flex items-center justify-center">
              <SafeIcon icon={icon} className="w-5 h-5 text-secondary-600" />
            </div>
          )}
          <div>
            <h3 className="font-semibold text-secondary-900 mb-1">{title}</h3>
            {category && (
              <span className={`text-xs font-medium px-2 py-1 rounded-full ${priorityTextClasses[priority]} ${priorityClasses[priority]}`}>
                {category}
              </span>
            )}
          </div>
        </div>
        
        {timestamp && (
          <div className="flex items-center text-xs text-secondary-500">
            <SafeIcon icon={FiClock} className="w-3 h-3 mr-1" />
            {timestamp}
          </div>
        )}
      </div>
      
      <p className="text-secondary-700 mb-4 text-sm leading-relaxed">{description}</p>
      
      {actions.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              className="flex items-center px-3 py-2 text-xs font-medium text-primary-600 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors"
            >
              {action.label}
              <SafeIcon icon={FiArrowRight} className="w-3 h-3 ml-1" />
            </button>
          ))}
        </div>
      )}
    </motion.div>
  );
};

export default InsightCard;